import React from 'react';
import '../Offers/Offer.css';
import bg from '../Assets/Frontend_Assets/bg.jpg';
import { useNavigate } from "react-router-dom";

const Offer = () => {
  const navigate = useNavigate(); // ✅ hook at top

  return (
    <div className="offer-banner">
      <img src={bg} alt="Offer" />

      <div className="overlay"></div>

      <div className="offer-content">
        <h1 className='subheading'>WELCOME TO See&Select</h1>
        <p className='h2'>EXTRAVAGANT FASHION FOR THE INDEPENDENT URBAN WOMAN/MEN</p>
        <p className='h3'>HANDCRAFTED. MADE TO MEASURE</p>

        <button onClick={() => navigate("/about")}>
          About Us
        </button>
      </div>
    </div>
  );
};

export default Offer;
